import {
  Box,
  Chip,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import logo from "assets/logos/logo-transparent-dark-bg.png";
import image from "assets/splashpage/annualsplash.png";

const AnnualBanner = () => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: 3,
        background: "linear-gradient(135deg, #004537 0%, #101828 100%)",
        overflow: "hidden",
        minHeight: "380px",
        position: "relative",
      }}
    >
      {/* Left column */}

      <Grid
        container
        sx={{ maxWidth: 1000, px: { xs: 2, md: 0 } }}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 3,
            maxWidth: isMobileScreen ? "100%" : "520px",
            zIndex: 1,
            pb: 6,
          }}
        >
          {/* Logo */}
          <Box
            component="a"
            href="https://www.onbento.com/?s=annual"
            sx={{ position: "relative", zIndex: 2 }}
          >
            <Box
              component="img"
              src={logo}
              alt="Bento"
              sx={{ height: 40, width: "auto", display: "block" }}
            />
          </Box>

          <Chip
            label="🔥 Save 25% on Annual Plans"
            sx={{
              backgroundColor: "rgba(255, 200, 0, 0.15)",
              color: "#FFC800",
              border: "1px solid rgba(255, 200, 0, 0.35)",
              fontWeight: 600,
              fontSize: "0.8rem",
              px: 0.5,
            }}
          />

          <Typography
            variant="h3"
            sx={{
              color: "#FFFFFF",
              fontWeight: 700,
              lineHeight: 1.2,
              fontSize: { xs: "1.75rem", md: "2.25rem" },
            }}
          >
            Your 24/7 assistant for landing brand deals
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "rgba(255, 255, 255, 0.7)",
              lineHeight: 1.65,
              fontSize: { xs: "0.95rem", md: "1rem" },
            }}
          >
            Bento finds brand contacts, writes personalized pitches, and sends
            follow-ups automatically. Stop spending hours on outreach and start
            landing more deals.
          </Typography>

          <Grid container gap={3}>
            <Box>
              <Typography>
                <Box sx={{ color: "white", fontSize: 30 }}>600k+</Box>
              </Typography>

              <Typography sx={{ color: "#99A1AF" }}>Contacts</Typography>
            </Box>

            <Box>
              <Typography>
                <Box sx={{ color: "white", fontSize: 30 }}>33x</Box>
              </Typography>
              <Typography sx={{ color: "#99A1AF" }}>
                more likely to land a brand deals
              </Typography>
            </Box>
          </Grid>
        </Box>

        {/* Right column — hidden on mobile */}
        {!isMobileScreen && (
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "flex-end",
              flexShrink: 0,
              height: "100%",
            }}
          >
            <Box
              component="img"
              src={image}
              alt="Annual plan preview"
              sx={{
                height: "400px",
                width: "auto",
                objectFit: "contain",
                display: "block",
              }}
            />
          </Box>
        )}
      </Grid>
    </Box>
  );
};

export default AnnualBanner;
